import React, { useState } from 'react';
import './ContactForm.css';

function ContactForm({ compact = false }) {
  const [formData, setFormData] = useState({
    nome: '', email: '', telefone: '',
    assunto: '', mensagem: '',
  });
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  // Formatação de Telefone: (XX) XXXXX-XXXX ou (XX) XXXX-XXXX
  const formatTelefone = (value) => {
    const numbers = value.replace(/\D/g, '').slice(0, 11);
    if (numbers.length <= 2) return numbers;
    if (numbers.length <= 6) return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    if (numbers.length <= 10) return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 6)}-${numbers.slice(6)}`;
    return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    // Aplica formatação conforme o campo
    if (name === 'telefone') {
      formattedValue = formatTelefone(value);
    }

    setFormData({ ...formData, [name]: formattedValue });
    
    // Dispara evento formstart na primeira interação
    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer.push({
        'event': 'formstart',
        'event_category': 'form',
        'event_label': 'contact_form',
        'form_name': 'ContactForm'
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEnviando(true);
    setErro('');
    try {
      // Prioridade: 1) config.js runtime, 2) .env, 3) fallback localhost
      const apiUrl = window.MSA_API_URL || process.env.REACT_APP_API_URL || 'https://msaportapaletes.com.br/backend-php/contato.php';
      const res = await fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
      const responseText = await res.text();
      let data = {};
      try {
        data = responseText ? JSON.parse(responseText) : {};
      } catch {
        data = { erro: 'O servidor retornou uma resposta inválida.' };
      }
      if (res.ok) {
        setEnviado(true);
        setFormData({
          nome: '', email: '', telefone: '',
          assunto: '', mensagem: '',
        });
        
        // Envia evento de conversão para GTM
        if (typeof window !== 'undefined' && window.dataLayer) {
          window.dataLayer.push({
            'event': 'form_submit',
            'event_category': 'form',
            'event_label': 'contact_form_success',
            'form_name': 'ContactForm'
          });
        }
        
        // Redirect automático para WhatsApp após 2 segundos
        setTimeout(() => {
          const whatsappNumber = '5521987940668';
          const message = encodeURIComponent('Olá! Acabei de enviar uma mensagem pelo formulário de contato.');
          window.open(`https://wa.me/${whatsappNumber}?text=${message}`, '_blank');
        }, 2000);
      } else {
        setErro(data.erro || 'Erro ao enviar. Tente novamente.');
      }
    } catch {
      setErro('Não foi possível conectar ao servidor. Tente novamente.');
    } finally {
      setEnviando(false);
    }
  };

  if (enviado) {
    return (
      <div className={`contact-form ${compact ? 'contact-form--compact' : ''}`}>
        <p className="contact-form__success">
          ✓ Mensagem enviada! Nossa equipe retornará em breve.
        </p>
      </div>
    );
  }

  return (
    <form className={`contact-form ${compact ? 'contact-form--compact' : ''}`} onSubmit={handleSubmit}>
      
      <div className="contact-form__field">
        <input 
          className="contact-form__input" 
          name="nome" 
          placeholder="Nome completo *"
          required 
          value={formData.nome} 
          onChange={handleChange} 
        />
      </div>

      <div className="contact-form__field">
        <input 
          className="contact-form__input" 
          name="email" 
          type="email"
          placeholder="E-mail *"
          required 
          value={formData.email} 
          onChange={handleChange} 
        />
      </div>

      <div className="contact-form__field">
        <input 
          className="contact-form__input" 
          name="telefone" 
          placeholder="Telefone (00) 00000-0000"
          value={formData.telefone} 
          onChange={handleChange} 
        />
      </div>

      <div className="contact-form__field">
        <select 
          className="contact-form__input contact-form__select" 
          name="assunto" 
          required 
          value={formData.assunto} 
          onChange={handleChange}
        >
          <option value="">Selecione o assunto *</option>
          <option>Orçamento</option>
          <option>Dúvida técnica</option>
          <option>Parceria</option>
          <option>Reclamação</option>
          <option>Outro</option>
        </select>
      </div>

      <div className="contact-form__field">
        <textarea 
          className="contact-form__input contact-form__textarea" 
          name="mensagem" 
          placeholder="Mensagem *"
          required 
          rows={4} 
          value={formData.mensagem} 
          onChange={handleChange} 
        />
      </div>

      <button type="submit" className="contact-form__btn" disabled={enviando}>
        {enviando ? 'Enviando...' : 'Enviar Mensagem'}
      </button>

      {erro && <p className="contact-form__error">{erro}</p>}
    </form>
  );
}

export default ContactForm;
